import { createSelector } from 'reselect';
import { initialState } from './reducer';

const selectGlobal = (state) => state.niveau || initialState;

const makeSelectNiveauFilterMenuStatus = () =>
  createSelector(selectGlobal, (niveauState) => niveauState.niveauFilterMenuStatus);

export { makeSelectNiveauFilterMenuStatus };
